//import React, {Component} from 'react';
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const styles = {
    card: {
        maxWidth: 450,
        height: 350
    },
    media: {
        // ⚠️ object-fit is not supported by IE 11.
        objectFit: 'cover',
    },
};


//'url(' + require('../../images/IMG_1.JPG')
class MoneyCard extends React.Component {

            constructor(props) {
                super(props);
                this.state = {
                    age: '',
                    name: 'hai',
                    labelWidth: 0,
                };
                //const unsubscribe = store.subscribe( () => {/*console.log(store.getState())*/});
            }

            render() {
            const {classes} = this.props;
            return (
                < Card
            className = {classes.card} elevation={20}>
                < CardActionArea >
                < CardMedia
            component = "img"
            alt = "Saving Environment"
            className = {classes.media}
            height = "140"
            image = { '/static/images/env1.jpg'}
                //image = {'../../images/money.jpg'}
            title = "Save Environment"
                / >
                < CardContent >
                < Typography
            gutterBottom
            variant = "h5"
            component = "h2" >
                Environment
                < /Typography>
                < Typography
            component = "p" >
               With your partcipation, you will help to reduce 80,000 metric tons of Co2 emissions in U.S.A every year!
            < /Typography>
            < /CardContent>
            < /CardActionArea>
              {/*}
            < CardActions >
            < Button
            size = "small"
            color = "primary" >
                Share
                < /Button>
                < Button
            size = "small"
            color = "primary"  href="#aboutplatewiz" >
                Learn
            More
            < /Button>
            < /CardActions> */}
            < /Card>
        )
            ;
        }//end of render
}//End of class

MoneyCard.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MoneyCard);